module.exports = __webpack_public_path__ + "img/setting.fbb24c4.svg";